<form [formGroup]="formSearch" class="ldp-search">
  <div style="margin-top: 3px;">
    <mat-form-field style="width: 130px; margin-right: 9px;" appearance="outline">
      <mat-label>ZIP Code</mat-label>
      <input
        matInput
        placeholder="ZIP Code"
        id="searchZIP"
        name="searchZIP"
        trim="blur"
        formControlName="searchZIP"
        autocomplete="postal-code"
      />
      <mat-error *ngIf="this.formSearch.get('searchZIP').invalid">{{getZipErrorMessage()}}</mat-error>
    </mat-form-field>
    <mat-form-field
      style="width: 250px;"
      appearance="outline"
    >
      <mat-label>Distance</mat-label>
      <select
        matNativeControl
        formControlName="searchDistance"
      >
        <option value="">-- Select One --</option>
        <option value="5">5 miles from ZIP Code</option>
        <option value="10">10 miles from ZIP Code</option>
        <option value="25">25 miles from ZIP Code</option>
        <option value="50">50 miles from ZIP Code</option>
        <option value="100">100 miles from ZIP Code</option>
        <option value="5000">Anywhere in California</option>
      </select>
      <mat-error>Distance is required</mat-error>
    </mat-form-field>
    <span fxHide fxShow.gt-sm> - OR - </span>
    <hr class="hr-text" data-content="OR" fxHide fxShow.lt-md style="margin-bottom:20px;">
    <mat-form-field
      style="width: 300px;"
      appearance="outline"
    >
    <mat-label>Email, Name or License</mat-label>
      <input
        matInput
        trim="blur"
        id="searchPhrase"
        name="searchPhrase"
        formControlName="searchPhrase"
        placeholder="Search Email, Name or License"
        style="width: 250px;"
        autocomplete="off"
      />
    </mat-form-field>
  </div>
</form>
<div *ngIf="waitForListingToShow">
  <mat-progress-bar value="40" mode="indeterminate"> </mat-progress-bar>
  <p>Loading licensed design professional directory...</p>
</div>

<div>
  <div>
    <div *ngIf="getZipErrorMessage() || isFormEmpty()">
      <p>Please enter information above to search</p>
      <br /><br />
    </div>
    <div *ngIf="!getZipErrorMessage() && !waitForListingToShow && noSearchResults && !isFormEmpty()">
      <p>No search results</p>
      <br /><br />
    </div>
    <div   fxLayout="row wrap" fxLayout.sm="column wrap" fxShow.lt-sm fxHide>
        <div *ngFor="let item of dataSourceTable.connect()|async" fxFlex.xs="100%" fxFlex.gt-xs="100%" fxFlex.gt-sm="50%" [fxFlex.gt-md]="cardLayout">
            <mat-card  class="mat-card mat-elevation-z7 {{this.specialCssClass}}">
                <div fxLayout="row wrap" fxLayoutGap="10px">
                    <div class="left-header" fxLayout="row" fxFlexAlign="left">
                        <div *ngIf="openOption === 'estimate'" class="select-contractor" fxFlexAlign="left"  >
                            <mat-checkbox
                            (change)="selection.toggle(item)"
                            [checked]="selection.isSelected(item)"
                            [aria-label]="checkboxLabel(item.id)"
                            [disabled]="disableSelection"
                            >
                            </mat-checkbox>
                        </div>
                    </div>
                    <mat-card-title-group    fxFlexAlign="left">
                        <mat-card-title class="mat-card-title business-name" matTooltip="Professional's Business name or Full name" >
                            <span
                                *ngIf="
                                item.businessName &&
                                item.businessName.trim() !== '';
                                else: otherName
                                "
                            >
                            {{ item.businessName }}
                            </span>
                            <div style="font-size: 18px;">
                              {{ item.firstName }} {{ item.lastName }} - {{ item.ldpLicenseTypeOptionSet }}
                            </div>
                           
                           
                        </mat-card-title>
                        <mat-card-subtitle class="card-subtitle mat-card-subtitle">
                         
                            (License #:
                            <span
                                *ngIf="
                                item.ldpLicenseNumber &&
                                item.ldpLicenseNumber.length > 0;
                                else: licenseNoUnavailable
                                "
                            >
                                {{ item.ldpLicenseNumber }})
                            </span>
                            <ng-template #licenseNoUnavailable>
                                <span>Unavailable)</span>
                            </ng-template>
                        </mat-card-subtitle>
                    </mat-card-title-group>
                </div>
                <mat-card-content fxHide>
                    <div (window:resize)="onResize($event)" >
                        <span>{{ this.screenWidth }}</span>
                    </div>
                </mat-card-content>
                <mat-card-content class="mat-card-content">
                    <mat-divider></mat-divider>
                </mat-card-content>
                <mat-card-content>
                    <div style="margin-top: 10px;">
                        <span>
                            {{ item.address2_Line1 }}, {{ !this.util.isEmpty(item.address2_Line2) ? item.address2_Line2 + ',' : '' }} {{ item.address2_City }}, {{ item.address2_StateOrProvince }}
                            {{ item.address2_PostalCode }}
                        </span>
                    </div>
                    <div style="font-size: 12px;">
                        Email: <a target="_blank" rel="noopener" href="mailto:{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}" class="truncateLongString">{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}</a>
                    </div>
                    <div style="font-size: 12px;">
                        Phone:
                        <span *ngIf="item.address2_Telephone1 && item.address2_Telephone1.length > 0; else: phoneUnavailable">
                        {{ this.util.formatPhone(item.address2_Telephone1) }}
                        </span>
                        <ng-template #phoneUnavailable>
                        <span>Unavailable</span>
                        </ng-template>
                    </div>
                    <div style="font-size: 12px;">
                        Web:
                        <span *ngIf="item.webSiteUrl && item.webSiteUrl.length > 0; else: websiteUnavailable" class="truncateLongString">
                        <a target="_blank" rel="noopener" href="{{formatLink(item.webSiteUrl)}}">{{formatLink(item.webSiteUrl)}}</a>
                        </span>
                        <ng-template #websiteUnavailable>
                        <span>Unavailable</span>
                        </ng-template>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div [hidden]="waitForListingToShow || noSearchResults || isFormEmpty()" class="mat-elevation-z7 scroll-table" width="100%" fxShow fxHide.lt-sm>
      <table mat-table [dataSource]="dataSourceTable" style="width: 100%;">
        <ng-container matColumnDef="checkbox">
          <td mat-cell width="10%" *matCellDef="let item">
            <div *ngIf="openOption === 'estimate'" style="text-align: center;">
              <mat-checkbox
                (change)="selection.toggle(item)"
                [checked]="selection.isSelected(item)"
                [aria-label]="checkboxLabel(item.id)"
                [disabled]="disableSelection"
              >
              </mat-checkbox>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="bizId">
          <td mat-cell width="35%"  style="height: 90px;" *matCellDef="let item">
            <div ngStyle.lt-md="{ 'margin-left': '9px' }">
              <div
                matTooltip="{{item.businessName}}"
                class="business-name"
              >
                <span  *ngIf="item.businessName && item.businessName.length > 0"
                >
                  {{ item.businessName }}
                </span>
              </div>
              <div style="font-size: 12px;">
                {{ item.firstName }} {{ item.lastName }} - {{ item.ldpLicenseTypeOptionSet }}
              </div>
              <div style="font-size: 12px;">
                {{ item.address2_Line1 }}, {{ !this.util.isEmpty(item.address2_Line2) ? item.address2_Line2 + ',' : '' }} {{ item.address2_City }}, {{ item.address2_StateOrProvince }}
                {{ item.address2_PostalCode }}
              </div>
              <div style="font-size: 12px;">
                (License #:
                <span
                  *ngIf="
                    item.ldpLicenseNumber &&
                      item.ldpLicenseNumber.length > 0;
                    else: licenseNoUnavailable
                  "
                >
                  {{ item.ldpLicenseNumber }})
                </span>
                <ng-template #licenseNoUnavailable>
                  <span>Unavailable)</span>
                </ng-template>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="bizContact">
          <td mat-cell width="35%" *matCellDef="let item">
            <div style="font-size: 12px;">
              Email: <a target="_blank" rel="noopener" href="mailto:{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}">{{item.emailAddress2?item.emailAddress2:item.emailAddress1}}</a>
            </div>
            <div style="font-size: 12px;">
              Phone:
              <span
                *ngIf="
                  item.address2_Telephone1 &&
                    item.address2_Telephone1.length > 0;
                  else: phoneUnavailable
                "
              >
                {{ this.util.formatPhone(item.address2_Telephone1) }}
              </span>
              <ng-template #phoneUnavailable>
                <span>Unavailable</span>
              </ng-template>
            </div>
            <div style="font-size: 12px;">
              Web:
              <span *ngIf="item.webSiteUrl && item.webSiteUrl.length > 0;  else: websiteUnavailable">
                <a target="_blank" href="{{formatLink(item.webSiteUrl)}}" rel="noopener">
                  {{formatLink(item.webSiteUrl)}}</a>
              </span>
              <ng-template #websiteUnavailable>
                <span>Unavailable</span>
              </ng-template>
            </div>
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      </div>
    <mat-paginator [hidden]="waitForListingToShow || noSearchResults || isFormEmpty()"
    [length]="dataResultsLength"
    [pageSizeOptions]="tablePageSizeOptions">
    </mat-paginator>
</div>
</div>





